document.addEventListener('DOMContentLoaded', function () {
  const mobileSearchToggle = document.querySelector('.search-icon-button');
  const mobileSearchPopup = document.querySelector('.mobile-search-popup');
  const closeSearch = document.querySelector('.close-search');

  if (mobileSearchToggle && mobileSearchPopup) {
    mobileSearchToggle.addEventListener('click', function () {
      mobileSearchPopup.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      setTimeout(() => {
        const searchInput = mobileSearchPopup.querySelector('.search-input');
        if (searchInput) searchInput.focus();
      }, 100);
    });

    closeSearch.addEventListener('click', function () {
      mobileSearchPopup.style.display = 'none';
      document.body.style.overflow = '';
    });
  }

  if (document.querySelector('.search-input')) {
    initPredictiveSearch();
  }

  function initPredictiveSearch() {
    const searchInputs = document.querySelectorAll('.search-input');
    const searchTimeout = 300;
    const resultLimit = 5;

    searchInputs.forEach((searchInput) => {
      let searchTimeoutID;
      let searchAbortController;
      const form = searchInput.closest('form');
      const resultsBox = form.querySelector('.predictive-search-results');
      if (!resultsBox) return;

      const handleSearch = () => {
        const currentSearchTerm = searchInput.value.trim();

        clearTimeout(searchTimeoutID);
        if (searchAbortController) {
          searchAbortController.abort();
          searchAbortController = null;
        }

        if (currentSearchTerm.length < 2) {
          resultsBox.style.display = 'none';
          return;
        }

        resultsBox.innerHTML = '<div class="predictive-search-loading"><div class="loading-spinner"></div></div>';
        resultsBox.style.display = 'block';

        const searchUrl = new URL('/search/suggest.json', window.location.origin);
        searchUrl.searchParams.set('q', currentSearchTerm);
        searchUrl.searchParams.set('resources[type]', 'product');
        searchUrl.searchParams.set('resources[limit]', resultLimit);
        searchUrl.searchParams.set('section_id', 'predictive-search');

        searchAbortController = new AbortController();
        const currentAbortController = searchAbortController;

        searchTimeoutID = setTimeout(() => {
          fetch(searchUrl, {
            signal: currentAbortController.signal,
          })
            .then((response) => {
              if (searchAbortController !== currentAbortController) return;
              if (!response.ok) throw new Error('Network response was not ok');
              return response.json();
            })
            .then((data) => {
              if (searchAbortController !== currentAbortController) return;
              displayResults(data, resultsBox, form.action, currentSearchTerm);
            })
            .catch((error) => {
              if (searchAbortController !== currentAbortController) return;
              if (error.name !== 'AbortError') {
                console.error('Search error:', error);
                resultsBox.innerHTML = '<div class="predictive-search-error">Error loading results</div>';
                resultsBox.style.display = 'block';
              }
            });
        }, searchTimeout);
      };

      searchInput.addEventListener('input', handleSearch);
      searchInput.addEventListener('focus', handleSearch);

      document.addEventListener('click', (e) => {
        if (!e.target.closest('.header-search') && !e.target.closest('.mobile-search-container')) {
          resultsBox.style.display = 'none';
        }
      });
    });

    function displayResults(data, resultsBox, searchAction, searchTerm) {
      resultsBox.innerHTML = '';
      const products = data.resources?.results?.products || [];

      if (products.length === 0) {
        resultsBox.innerHTML = '<div class="predictive-search-no-results">No results found</div>';
        resultsBox.style.display = 'block';
        return;
      }

      products.forEach((product) => {
        const productUrl = product.url || `${window.Shopify.routes?.root || '/'}products/${product.handle}`;
        const imageUrl = product.image
          ? product.image.replace(/\.(jpg|jpeg|png|gif)/i, '_100x.$1')
          : 'https://cdn.shopify.com/s/assets/no-image-100x-6f0b0c0bcd3bcae58a77ca96dd7b9a58.svg';

        let priceHtml = '';
        if (typeof product.price === 'number') {
          const price = product.price / 100;
          const compareAt = typeof product.compare_at_price === 'number' && product.compare_at_price > product.price
            ? product.compare_at_price / 100
            : null;

          if (window.theme?.currency?.formatMoney && window.theme.moneyFormat) {
            const formattedPrice = theme.currency.formatMoney(product.price, theme.moneyFormat);
            const formattedCompareAt = compareAt
              ? theme.currency.formatMoney(product.compare_at_price, theme.moneyFormat)
              : null;

            priceHtml = formattedCompareAt
              ? `<span class="current-price">${formattedPrice}</span> <span class="compare-at-price">${formattedCompareAt}</span>`
              : `<span class="current-price">${formattedPrice}</span>`;
          } else {
            priceHtml = compareAt
              ? `<span class="current-price">$${price.toFixed(2)}</span> <span class="compare-at-price">$${compareAt.toFixed(2)}</span>`
              : `<span class="current-price">$${price.toFixed(2)}</span>`;
          }
        }

        const resultItem = document.createElement('a');
        resultItem.className = 'predictive-search-item';
        resultItem.href = productUrl;
        resultItem.innerHTML = `
          <img src="${imageUrl}" alt="${product.title}" class="search-product-image">
          <div class="search-item-details">
            <span class="search-item-title ">${product.title}</span>
            <span class="search-item-price">$ ${product.price}</span>
          </div>
        `;

        resultsBox.appendChild(resultItem);
      });

      const viewAllLink = document.createElement('a');
      viewAllLink.className = 'predictive-search-view-all';
      viewAllLink.href = `${searchAction}?q=${encodeURIComponent(searchTerm)}&type=product`;
      viewAllLink.textContent = window.theme?.strings?.generalSearchViewAll || 'View all results';
      resultsBox.appendChild(viewAllLink);

      resultsBox.style.display = 'block';
    }
  }
});
